// this.formLIst()
/**
 * 基础菜单 商品管理
 */
<template>
  <div style="background:;">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->


    <el-form :inline="true"  ref="formInline" :model="formInline"  class="user-search">
      <el-form-item label="用户昵称" prop="nickName">
        <el-input maxlength="10"  size="small" clearable v-model="formInline.nickName" placeholder="输入用户昵称"></el-input>
      </el-form-item>
     
      <el-form-item prop="phone" label="手机号码">
        <el-input maxlength=11 size="small"  clearable  v-model="formInline.phone" placeholder="输入手机号码"></el-input>
      </el-form-item>
      
      <el-form-item prop="sex"  label="性别">
    <el-select v-model="formInline.sex" placeholder="不限">
      <el-option label="不限" value="0"></el-option>
      <el-option label="男" value="1"></el-option>
      <el-option label="女" value="2"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item prop="education" label="学历">
    <el-select v-model="formInline.education" placeholder="请选择">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
  </el-form-item>
  <el-form-item prop="version" label="版本号">
        <el-input size="small" clearable v-model="formInline.version" placeholder="输入版本号"></el-input>
      </el-form-item>
      <el-form-item prop="registerType" label="注册类型">
    <el-select v-model="formInline.registerType" placeholder="不限">
      <el-option label="不限" value=""></el-option>
      <el-option label="小程序" value="1"></el-option>
     
    </el-select>
  </el-form-item>
  
  <el-form-item prop="source" label="客户来源">
    <el-select v-model="formInline.source" placeholder="请选择">
    <el-option
      v-for="item in source"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
  </el-form-item>
  <el-form-item prop="registerAddress" label="注册地区">
    <el-cascader
          v-model="formInline.registerAddress"
          :options="options123"
          @change="onChange"
          :props="{ checkStrictly: true }"
          clearable></el-cascader>
      </el-form-item>
      <el-form-item prop="registerIpAddress" label="注册ip地区">
        <el-cascader
          v-model="formInline.registerIpAddress"
          :options="options1234123"
          @change="onChanges"
          :props="{ checkStrictly: true }"
          clearable></el-cascader>


</el-form-item>
<el-form-item prop="beginRegisterTime" label="注册时间">
    <el-col :span="11">
      <el-date-picker  value-format="yyyy-MM-dd HH:mm:ss"    type="datetime" placeholder="选择日期" v-model="formInline.beginRegisterTime" style="width: 100%;"></el-date-picker>
    </el-col>
    <el-col class="line" :span="2">&nbsp;&nbsp;&nbsp;&nbsp;-</el-col>
    <el-col :span="11">
      <el-form-item prop="endRegisterTime" label="">
        <el-date-picker   value-format="yyyy-MM-dd HH:mm:ss"     type="datetime" placeholder="选择日期" v-model="formInline.endRegisterTime" style="width: 100%;"></el-date-picker>

      </el-form-item>
   
    </el-col>
  </el-form-item>
  <el-form-item prop="beginAge" label="年龄">
    <el-col :span="4">
      <el-input size="small" clearable  v-model="formInline.beginAge" placeholder="不限"></el-input>
    </el-col>
    <el-col class="line" :span="2"> &nbsp;&nbsp;&nbsp; -</el-col>
    <el-col :span="4">
      <el-form-item prop="endAge" label="">
        <el-input size="small" clearable  v-model="formInline.endAge" placeholder="不限"></el-input>
      </el-form-item>
      
    </el-col>
  </el-form-item>

<el-form-item>

     

</el-form-item>
<div style=" float: right; margin-right: 50px; margin-bottom: 50px; ">
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button @click="resetForm('formInline')">重置</el-button>
       
        </div> 
    </el-form> 
  
  </div>
  
</template>

<script>

import Axios from 'axios'



import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      srcList: [
        ],
      listData:"",
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {

 

    // this.getdata(this.formInline)
  },
   mounted(){
    Axios({
  method: 'get',

  url: 'https://platform.ynhlminiapp.com/api/platform-account/detail',
  params:{
    accountId: this.$route.query.id
  }
    
}).then(res=>{
  this.listData =res.data.data

      
  console.log(res);
})
    // this.formLIst()
   },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    Clickbutton(id){
      // console.log(111);
      this.$router.push({
    path:"/goods/undataList",
    query:{ //query是个配置项
        id:id
    }
})

    },
    goBack(){
 
      this.$router.push({
    path:"/pay/Order",
    
})
    },
    adder(){
     this.srcList = this.listData.headIcon
    },
    handleClose(){

    },

    selectalls(rows){
      // console.log(row);
              //  return console.log("rows : "+JSON.stringify(rows));
                if(rows){
                  rows.forEach(row =>{
                    this.$refs.multipleTable.toggleRowSelection(row);
                  });
                }else{
                    this.$refs.multipleTable.clearSelection();//清除全选
                }
              },


   
    selectall(val){
      this.importList
    console.log(val);
    },
    handleSelectionChange(val) {
        this.multipleSelection = val;
      },
    // 导出数据
    imporList(){
      this.dialogVisible=true
    },
    select(selection, row){
      selection.forEach((item)=>{
      
        this.importList=item.id
        // console.log(this.importList);

      })
      
      // console.log(this.importList);
      // console.log(selection);
    },
    resetForm(formInline) {
  //  this.formInline =''
        this.$refs[formInline].resetFields();
      },


   
    formatData(row, column, cellValue, index){
		
		//把传过来的日期进行回炉重造一下，又创建了一个js的 Date对象，进行重新构造，转为String字符串
		//最终返回 s 就可以了
		var s =	new Date(cellValue).toLocaleString();
	    return s;

		  // 测试参数含义：不知道参数是什么含义的就打印出来
		  // console.log(row)     	//拿到一行的所有信息，要拿到具体信息,只需要row.XXX 就可以了
		  // console.log(column)  	//拿到列的信息
		  // console.log(cellValue) //拿到单元格数据，拿到时间 2022-03-18T01:46:08.000+00:00
		  // console.log(index)     //拿到索引
	    },

    // 获取公司列表
   
    // 分页插件事件
    callFather(parm) {
      console.log(parm);

      this.formInline.size = parm.pageSize
      this.formInline.current = parm.currentPage
      this.formLIst()
    },
    // 搜索事件
    search() {
this.formLIst()
      
      // console.log(this.formInline);
      // this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.deptId = row.deptId
        this.editForm.deptName = row.deptName
        this.editForm.deptNo = row.deptNo
      } else {
        this.title = '添加'
        this.editForm.deptId = ''
        this.editForm.deptName = ''
        this.editForm.deptNo = ''
      }
    },
  

  }
}
</script>

<style scoped >
.separators{
  /* width: 100%; */
 
  background-color:#fff;
  margin-top: 30px;
  position: relative;


}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/goods/undataList.vue